import { render, staticRenderFns } from "./Notificaciones.vue?vue&type=template&id=248f412f&scoped=true"
import script from "./Notificaciones.vue?vue&type=script&lang=js"
export * from "./Notificaciones.vue?vue&type=script&lang=js"
import style0 from "./Notificaciones.vue?vue&type=style&index=0&id=248f412f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f412f",
  null
  
)

export default component.exports